<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
      <v-flex xs12>
        <v-btn fab x-small @click="$router.go(-1)">
          <v-icon>navigate_before</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 md1 class="mb-2">
        <v-btn
          fab
          small
          @click="printTable()"
          class="ml-8 white--text"
          color="#2b6993"
          elevation="4"
          absolute
          right
        >
          <v-icon>print</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <h3 class="text-center mb-5">Staff Certifications Report</h3>
        <!-- <h5 class="text-center mb-5">*By default, report pulls certifications that have a set expiration date</h5> -->
        <v-divider class="ml-4 mr-4 mb-3"></v-divider>
      </v-flex>

      <v-flex xs12>
        <v-card class="ma-3 pa-3" elevation="0">
          <v-layout row wrap>
            <v-flex xs12 md6 class="pa-1">
              <v-menu
                ref="calendarMenu"
                v-model="calendarMenu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportFilters.startDate"
                    label="Expiration Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="requiredField"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.startDate"
                  no-title
                  scrollable
                  :rules="requiredField"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="calendarMenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.calendarMenu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md6 class="pa-1">
              <v-menu
                ref="calendar2Menu"
                v-model="calendar2Menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportFilters.endDate"
                    label="Expiration End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="requiredField"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.endDate"
                  no-title
                  scrollable
                  :rules="requiredField"
                  :min="minEndDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="calendar2Menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.calendar2Menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 md6 class="pa-1 mb-2">
              <v-select
                label="Certification Status"
                :items="statusList"
                v-model="reportFilters.certificationStatus"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 md6 class="pa-1 mb-2">
              <v-select
                label="Certifications"
                :items="certs"
                item-text="Name"
                item-value="Name"
                v-model="reportFilters.certification"
                clearable
              ></v-select>
            </v-flex>

            <v-flex xs12 md4 class="pa-1 mb-2">
              <v-select
                label="Staff Status"
                :items="staffStatuses"
                v-model="reportFilters.staffStatus"
                clearable
              ></v-select>
            </v-flex>
            <v-flex  xs12 md4 class="pa-1 mb-2">
                <v-select
                  label="Select Program"
                  :items="programsSelection"
                  item-text="Name"
                  item-value="Name"
                  v-model="reportFilters.filterProgram"
                  clearable
                ></v-select>
            </v-flex>

            <v-flex xs12 md4 class="pa-1 mb-2">
              <v-combobox
                label="Select Staff"
                :items="employees"
                item-text="Name"
                item-value="_id"
                v-model="reportFilters.StaffID"
                clearable
                prepend-icon="person"
              >
                <template v-slot:item="{ item }">
                  {{ item.Name }} -
                  <v-btn
                    v-if="item.State === 'Utah'"
                    x-small
                    color="indigo darken-1"
                    dark
                    class="ml-2"
                  >
                    UT
                  </v-btn>

                  <v-btn
                    x-small
                    color="green darken-1"
                    v-if="item.State === 'Nevada'"
                    dark
                    class="ml-2"
                  >
                    NV
                  </v-btn>
                </template>
              </v-combobox>
            </v-flex>

            <v-flex xs12 md2 class="mt-4 pl-4">
              <v-btn @click="expirationQuery()">Search</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-2">
        <v-data-table
          :headers="headers"
          :items="certifications"
          sort-by="Expiration"
          sort-asc
          class="elevation-1"
          :loading="isLoading"
          loading-text="Loading Expiring Certifications"
        >
          <template v-slot:item.select="{ item }">
            <v-btn
              x-small
              class="white--text"
              color="#2b3990"
              @click="viewCertification(item)"
            >
              View
            </v-btn>
          </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="80%">
          <v-card>
            <v-card-title style="background-color: #2b3990">
              <span class="headline white--text">{{ titleForm }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                      v-model="newCertificationType"
                      label="Certification Type"
                      :items="status"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                      v-model="newCertification"
                      label="Certification"
                      :items="certs"
                      item-text="Name"
                      item-value="Name"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      v-model="newFocus"
                      label="Focus"
                      outlined
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      v-model="newDetails"
                      label="Details"
                      outlined
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newDateIssued"
                          label="Date Issued"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newDateIssued"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newExpiration"
                          label="Certification Expires"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newExpiration"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu2 = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu2.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      v-model="newNotes"
                      label="Notes"
                      outlined
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      label="Certification Status"
                      :items="certStatus"
                      v-model="newStatus"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <form enctype="multipart/form-data">
                      <v-file-input
                        v-model="newDocument"
                        class="pa-2"
                        label="Certification"
                        filled
                        multiple
                        prepend-icon="mdi-camera"
                        accept="image/*, .pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"
                        show-size
                      >
                        <template #selection="{ text, index }">
                          <v-chip
                            small
                            label
                            close
                            color="primary"
                            @click:close="deleteChip(index)"
                            >{{ text }}</v-chip
                          >
                        </template>
                      </v-file-input>
                    </form>
                  </v-col>
                  <v-carousel v-if="imageDetails.length > 0">
                    <template v-for="(item, index) in imageDetails">
                      <v-carousel-item :key="index">
                        <v-row class="flex-nowrap" style="height: 100%">
                          <v-img :src="item.AWSLink">
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center"
                            >
                              <div style="color: #000; padding-top: 30%">
                                {{ item.Name }}
                              </div>
                            </v-row>
                          </v-img>
                        </v-row>
                      </v-carousel-item>
                    </template>
                  </v-carousel>
                  <iframe
                    id="pdf"
                    v-if="pdfDetails.length > 0"
                    style="width: 90%; min-height: 600px; margin: 20px auto"
                  ></iframe>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#259647"
                class="white--text"
                @click="addStaffCert()"
                v-if="newStaffCert"
                >Save</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="updateStaffCert()"
                v-if="editStaffCert"
                >Update</v-btn
              >
              <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <div id="print">
      <report-header>
        <h2>Staff Expiring Certifications Report</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="certifications"
            sort-by="Expiration"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Certifications"
            :items-per-page="-1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import axios from "axios";
import { PDFDocument } from "pdf-lib";
import {
  STATUS_ARRAY,
  STATUSES as UserStatus,
} from "../../enums/UserStatusEnum";
import { STATUSES as StaffStatus } from "../../enums/StaffStatusEnum";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import ReportFilters from '@/mixins/reportFilters.js';

// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
  mixins: [
    ReportFilters,
  ],
  components: {
    ReportHeader
  },

  data: () => ({
    headers: [
      {
        text: "Expiration Date",
        align: "start",
        sortable: true,
        value: "Expiration",
      },
      { text: "Employee", value: "employee.Name" },
      { text: "Certification Type", value: "CertificationType" },
      { text: "Certification", value: "Certification" },
      { text: "Notes", value: "Notes" },
      { text: "Date Issued", value: "DateIssued" },
      { text: "", value: "select" },
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    employees: [],
    certifications: [],
    dialog: false,
    StaffID: "",
    calendarMenu: false,
    calendar2Menu: false,
    report: "",
    staff: "",
    clientName: "",
    isLoading: false,
    userState: localStorage.getItem("userState"),
    requiredField: [(v) => !!v || "This is required"],
    newCertificationType: "",
    newCertification: "",
    newFocus: "",
    newDetails: "",
    newDateIssued: "",
    newExpiration: "",
    newNotes: "",
    newStatus: "",
    certStatus: ["Current", "Archived"],
    newDocument: [],
    imageDetails: [],
    pdfDetails: [],
    newDocumentImage: "",
    status: ["State Required", "Mandatory", "Elective"],
    certs: [],
    editStaffCert: false,
    newStaffCert: false,
    menu: false,
    menu2: false,
    fileSelected: "",
    titleForm: "",
    msg: false,
    text: "",
    statusList: ["Current", "Expired", "Archived"],
    staffStatuses: STATUS_ARRAY,
    certs: [],
    programsSelection: [],
    reportFilters:  {
        startDate: '',
        endDate: '',
        certificationStatus: '',
        certification: '',
        staffStatus: '',
        filterProgram: '',
        StaffID: '',
    },
    reportFilterName: 'ReportFilters_StaffCertificationsReport',
  }),

  computed: {
    minEndDate() {
      return this.reportFilters.startDate ? this.reportFilters.startDate : null;
    },
    filteredEmployees() {
      const employees = this.employees;
      const staffStatus = this.reportFilters.staffStatus;

      if (staffStatus === UserStatus.INACTIVE) {
        return employees.filter(
          (employee) => employee.Status == StaffStatus.TERMINATED
        );
      }

      if (staffStatus === UserStatus.ACTIVE) {
        return employees.filter(
          (employee) =>
            employee.Status == StaffStatus.FULL_TIME ||
            employee.Status == StaffStatus.PART_TIME
        );
      }
      return employees;
    },
  },

  created() {
    this.getEmployees();
    this.getCertifications();
    this.getPrograms();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },

  watch: {
    reportFilters: {
      handler(newVal) {
        this.setReportFilters(this.reportFilterName, newVal);
      },
      deep: true
    }
  },

  methods: {
    initialize() {
      this.certifications = [];
    },

    getEmployees() {
      let endpoint = "";
      const companyIds = localStorage.getItem("userCompanies");

      endpoint = `${url}/users/state/${this.userState}`;

      axios
        .get(endpoint, {
          params: {
            Company: JSON.parse(companyIds),
          },
        })
        .then((res) => {
          this.employees = res.data.users;
        });
    },
    close() {
      this.dialog = false;
    },

    // getCertifications: function () {
    //   axios.get(`${url}/certifications`).then(async (res) => {
    //     this.certs = res.data.Active;
    //   });
    // },

    // expirationQuery() {
    //   this.certifications = []
    //   this.isLoading = true;
    //   // console.log(this.StaffID + " this is the id")
    //   if(this.StaffID===""){
    //     axios.get(`${url}/staffCertifications/${this.startDate}/${this.endDate}`).then(res => {
    //     var temp = res.data.staffCerts
    //     for(var i = 0; i < temp.length; i++){
    //       if(this.state == temp[i].EmployeeID.State){
    //         this.certifications.push(temp[i])
    //       }
    //     }
    //     this.isLoading = false
    //     })
    //   } else {
    //     axios.get(`${url}/staffCertifications/expired/${this.StaffID}/${this.startDate}/${this.endDate}`).then(res => {
    //     var temp = res.data.staffCerts
    //     for(var i = 0; i < temp.length; i++){
    //       if(this.state == temp[i].EmployeeID.State){
    //         this.certifications.push(temp[i])
    //       }
    //     }
    //     this.isLoading = false
    //   })
    //   }

    // },

    expirationQuery() {
      this.certifications = [];
      this.isLoading = true;

      const companyIds = localStorage.getItem("userCompanies");

      axios
        .get(`${url}/staffCertifications/report/query`, {
          params: {
            startDate: this.reportFilters.startDate,
            endDate: this.reportFilters.endDate,
            staffID: this.reportFilters.StaffID._id,
            state: this.userState,
            status: this.reportFilters.certificationStatus,
            Company: JSON.parse(companyIds),
            staffStatus: this.reportFilters.staffStatus,
            certification: this.reportFilters.certification,
            staffProgram: this.reportFilters.filterProgram
          },
        })
        .then((res) => {
          this.certifications = res.data.certifications;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateStaffCert() {
      var req_body = {
        CertificationType: this.newCertificationType,
        Certification: this.newCertification,
        Focus: this.newFocus,
        Details: this.newDetails,
        DateIssued: this.newDateIssued,
        Expiration: this.newExpiration,
        Notes: this.newNotes,
        Status: this.newStatus,
      };
      axios
        .put(`${url}/staffCertifications/${this.staffCertID}`, req_body)
        .then((response) => {
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          if (this.uploadFile !== null && this.uploadFile !== undefined) {
            this.saveFile();
          }
          this.msg = true;
          this.text =
            "The certification has been updated successfully. Please refresh";
        });
      this.close();
    },

    //   getStaffID(item) {
    //   this.staff = item.EmployeeID;
    //   window.localStorage.setItem('staffId', this.staff)
    //   console.log(this.staff + " is the staff")
    // },

    viewCertification(item) {
        console.log({item});
        this.$router.push({
            path: `/viewStaffCertification/${item._id}`,
            query: {viewCertification: 'true'},
        })
    },

    async loadPdf(url) {
      let fetching = [];
      for (let i = 0; i < url.length; i++) {
        const existingPdfBytes = await fetch(url[i]).then((res) =>
          res.arrayBuffer()
        );
        fetching.push(existingPdfBytes);
      }

      let load = [];
      for (let i = 0; i < fetching.length; i++) {
        const pdfDoc = await PDFDocument.load(fetching[i]);
        load.push(pdfDoc);
      }

      const pdfDocCreate = await PDFDocument.create();
      let copy = [];
      for (let i = 0; i < load.length; i++) {
        const [firstDonorPage] = await pdfDocCreate.copyPages(load[i], [0]);
        copy.push(firstDonorPage);
      }

      let counter = 0;
      for (let i = 0; i < copy.length; i++) {
        if (i == 0) {
          pdfDocCreate.addPage(copy[i]);
        } else {
          pdfDocCreate.insertPage(counter, copy[i]);
          counter++;
        }
      }

      const fDataUri = await pdfDocCreate.saveAsBase64({ dataUri: true });
      document.getElementById("pdf").src = fDataUri;
    },

    printTable() {
      window.print();
    },


    getCertifications: function() {
      axios.get(`${url}/certifications`).then(async res => {
          this.certs = res.data.Active;
      });
    },    

    async getPrograms() {
      const companyIds = localStorage.getItem("userCompanies");

      await axios
        .get(`${url}/units/state/${this.userState}`, {
          params: {
            Company: JSON.parse(companyIds),
          },
        })
        .then((res) => {
          this.programsSelection = res.data.units;
        });
    },
  },
};
</script>
<style>
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
